module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-screen"
  }, [(_vm.artwork) ? _c('slick', {
    ref: "loginSlider",
    staticClass: "login-slider",
    attrs: {
      "options": _vm.slickOptions
    },
    on: {
      "afterChange": _vm.setCurrentSlide
    }
  }, _vm._l((_vm.artwork), function(art, $index) {
    return _c('div', {
      staticClass: "art-wrapper"
    }, [_c('div', {
      staticClass: "artwork",
      class: {
        'animated': $index === _vm.currentSlide
      },
      style: ({
        backgroundImage: 'url(' + art.url + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "credit"
    }, [_vm._v(_vm._s(art.credit))])])
  })) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "login"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png"),
      "alt": "ThinkTank Online"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Portal")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.showRegistrationInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registrationCode),
      expression: "registrationCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "registration_code",
      "placeholder": "Registration Code"
    },
    domProps: {
      "value": (_vm.registrationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registrationCode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showRegistrationInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login-email",
      "type": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.username = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showRegistrationInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login-password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showRegistrationInput) ? _c('a', {
    staticClass: "forgot-password",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.forgotPassword()
      }
    }
  }, [_vm._v("Forgot Password?")]) : _vm._e(), _vm._v(" "), (_vm.showRegistrationInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email Address",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.username = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRegistrationInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Set Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.password = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showRegistrationInput) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.register()
      }
    }
  }, [_vm._v("Activate Account")]) : _vm._e(), _vm._v(" "), (!_vm.showRegistrationInput) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "login-submit",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.login()
      }
    }
  }, [_vm._v("Enter")]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4022a82f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 2032
// module chunks = 2